// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1B40Z","buttons":"SendReceipts_buttons__24QjH","email":"SendReceipts_email__3vbJu","bookApptTitle":"SendReceipts_bookApptTitle__3LkC-"};